// src/services/equipmentService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  EQUIPMENT_LIST,
  EQUIPMENT_ADD,
  EQUIPMENT_UPDATE,
  EQUIPMENT_DELETE,
} from "../../config/constants"; // Adjust endpoints as per your config

const equipmentService = createApi({
  reducerPath: "equipmentService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Equipment"],
  endpoints: (builder) => ({
    getEquipments: builder.query({
      query: (bodyData) => ({
        url: EQUIPMENT_LIST, // Endpoint to fetch meal list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Equipment"],
    }),
    addEquipment: builder.mutation({
      query: (mealData) => ({
        url: EQUIPMENT_ADD, // Endpoint to add a meal
        method: "POST",
        data: mealData, // Equipment data for the request body
      }),
      invalidatesTags: ["Equipment"],
    }),
    updateEquipment: builder.mutation({
      query: ({ mealId, updatedData }) => ({
        url: `${EQUIPMENT_UPDATE}/${mealId}`, // Endpoint to update a meal
        method: "PUT",
        data: updatedData, // Updated meal data
      }),
      invalidatesTags: ["Equipment"],
    }),
    deleteEquipment: builder.mutation({
      query: (mealId) => ({
        url: `${EQUIPMENT_DELETE}/${mealId}`, // Endpoint to delete a meal
        method: "DELETE",
      }),
      invalidatesTags: ["Equipment"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetEquipmentsQuery,
  useAddEquipmentMutation,
  useUpdateEquipmentMutation,
  useDeleteEquipmentMutation,
} = equipmentService;

// Export the reducer to be included in the store
export default equipmentService;
